import { useLocation, Outlet } from "react-router-dom";
import AdminNavbar from "./Components/AdminNavbar";

function AdminLayout() {
  const location = useLocation();
  const noNavbarRoutes = ["/login", "/register"];

  return (
    <>
      {!noNavbarRoutes.includes(location.pathname) && <AdminNavbar />}
      <div className="page-content">
        <Outlet />
      </div>
    </>
  );
}

export default AdminLayout;
